export default {
    "en": {
        "app": {
            "common": {
                "email": "Email send successfully",
                "login": "Login",
                "impersonate": "Impersonate",
                "enter": "Enter",
                "yes": "Yes",
                "no": "No",
                "of": "of",
                "on": "on",
                "by": "by",
                "back": "Back",
                "next": "Next",
                "prev": "Prev",
                "continue": "Continue",
                "create": "Create",
                "close": "Close",
                "select": "Select",
                "selected": "Selected",
                "loading": "Loading",
                "refresh": "Refresh this page",
                "sort": "Sort by this column",
                "toggle": "Toggle",
                "all": "All",
                "no_results": "No results",
                "list_results": "Showing {current} of {total} records",
                "save_changes": "Save changes",
                "changes_saved": "Changes saved successfully.",
                "cancel": "Cancel",
                "edit": "Edit",
                "more": "More",
                "add_more": "Add more",
                "remove": "Remove",
                "upload": "Upload",
                "enable": "Enable",
                "disable": "Disable",
                "enabled": "Enabled",
                "disabled": "Disabled",
                "activate": "Activate",
                "active": "Active",
                "resume": "Resume",
                "resumed": "Resumed",
                "submit": "Submit",
                "verify": "Verify",
                "oops": "Oops! Something went wrong.",
                "unauthorized": "Oops! It seems your subscription is inactive.",
                "subscribe": "Activate my subscription",
                "contact_admin": "Get in touch with your administrator to activate this subscription",
                "never": "Never",
                "download": "Download",
                "download_all": "Download all",
                "download_csv": "Download as CSV",
                "download_pdf": "Download as PDF",
                "download_xls": "Download as XLS",
                "optional": "optional",
                "copy": "Copy",
                "copied": "Copied",
                "advanced": "Advanced settings",
                "macros": "Macros",
                "phone": "Phone number",
                "make_copy": "Make a copy",
                "resize": "Drag to resize",
                "from": "From",
                "to": "To",
                "rows": "Lines",
                "visible": "Visible",
                "system_default": "System's default",
                "quick_search": "Quick search...",
                "page": "Page",
                "content": "Content",
                "http": "http://",
                "required": "Mandatory field",
                "none": "None",
                "other_type": "Other (please type)",
                "broken": "We were unable to save this field value. Please change it to retry.",
                "calculated": "This field is calculated automatically and cannot be edited.",
                "readonly": "This field cannot be modified.",
                "sign": "Click to sign",
                "signed": "Signed by",
                "signed_on": "Signature date",
                "date": "Date",
                "save": "Save",
                "type": "Type",
                "draw": "Draw",
                "clear_all": "Clear all",
                "not_allowed": "Not allowed",
                "ip_address": "IP address",
                "any": "any value",
                "when": "When",
                "minutes": "min",
                "seconds": "sec",
                "wait": "Please wait...",
                "processing": "Processing!",
                "reload": "Click here to reload this page.",
                "created": "Created ",
                "send_resend": "Send / Resend",
                "expand": "Expand",
                "collapse": "Collapse"
            },
            "confirm": {
                "message": "Please input your password to proceed.",
                "description": "This operation cannot be undone.",
                "cancel": "Cancel",
                "proceed": "Proceed",
                "password": "Password",
                "dirty": "There are unsaved changes. Are you sure you wish to leave?"
            },
            "address": {
                "address1": "Address line 1",
                "address2": "Address line 2",
                "city": "City",
                "state": "State/Province",
                "zip": "ZIP/Postal code",
                "country": "Country"
            }
        },
        "front": {
            "buttons": {
                "start": "Start",
                "next": "Next",
                "previous": "Prev",
                "finish": "Finish",
                "add_more": "Add more",
                "add_coclient": "Add Co-client",
                "remove": "Remove",
                "upload": "Upload",
                "droptoupload": "Drop to upload",
                "toggle": "Expand / Collapse",
                "continue": "Continue",
                "cancel": "Cancel",
                "verify": "Verify",
                "create": "Create",
                "signin": "Sign-in",
                "signup": "Sign-up",
                "forgot": "Forgot your password?",
                "pin": "Send me the PIN",
                "pin_request": "Request a security PIN",
                "contact": "Send us a message",
                "copy_address": "Copy address from",
                "the": "the",
                "on": "on",
                "of": "of",
                "page": "Page",
                "type": "Type",
                "draw": "Draw",
                "save": "Save",
                "select": "Select",
                "required": "Mandatory field",
            },
            "coclient": {
                "label": "Co-client",
                "message": "Click here to add information related to your spouse or partner."
            },
            "auth": {
                "title": "Verify your identity",
                "pin_message": "Please enter the security PIN sent to your",
                "phone_number": "mobile phone number",
                "email": "email address",
                "pin_number": "Security PIN",
                "pin_advisor": "Please enter the security PIN provided by your advisor",
                "password_message": "Please input your secure password.",
                "password_forgot": "To create a new secure password you need to enter a <strong>security PIN</strong> sent to",
                "password_pin": "You will need a security PIN to create a new secure password.",
                "password_create": "Please create your secure password.",
                "signin_message": "To access this engagement you need to enter a <strong>security PIN</strong> sent to",
                "phone_error": "We cannot find your mobile phone number. Please provide it to your advisor before trying to access this engagement.",
                "pin_success": "We will contact you shortly with the security PIN required to access this engagement.",
                "pin_error": "The security PIN you've entered does not match our records!",
                "pin_help": "If you did not receive a security PIN, please contact us.",
                "security_pin_required": "You will need a security PIN to create a new secure password.",
                "didnotreceivepin": "If you did not receive your security PIN",
                "requestithere": "request it here",
                "email_message": "Please input your email address and password.",
                "email_only_message": "Please input your email address.",
                "password": "Password",
                "password_confirm": "Confirm password",
                "password_error": "Invalid password!",
                "signin": "Already have an account?",
                "signin_button": "Sign in here",
                "signup": "Don't have an account?",
                "signup_button": "Sign up here",
                "signup_message": "Create your account below.",
                "signup_error": "An error has occurred creating your account.",
                "email_error": "The email address you've entered already exists.",
                "first_name": "First name",
                "last_name": "Last name",
                "error_message": "Please verify your input and try again.",
                "sms_body": "Your security PIN is:",
                "email_subject": "Security PIN for the engagement:",
                "email_greeting": "Dear",
                "email_body": "Below is the Security PIN to access the engagement:",
                "emailmessage_trouble": "If you\'re having trouble clicking the button above, copy and paste the URL below into your web browser:",
                "emailmessage_generated": "This email is auto-generated by",
                "emailmessage_noreply": "Please do not reply."
            },
            "closed": {
                "title": "This engagement has already been completed.",
                "description": "If you wish to continue working in this engagement, please contact us.",
                "success": "Your message has been received and we will get in touch once we restore your access to this engagement."
            },
            "blocked": {
                "title": "Your access has been blocked for security reasons.",
                "description": "Please contact us to restore your access.",
                "success": "Your message has been received and we will get in touch once your access has been restored."
            },
            "error": {
                "title": "An unexpected error has occurred!",
                "description": "Please refresh your browser and try again. If the issue persists, contact us.",
                "phone": "Unable to find a mobile number in your account!",
                "phone_help": "A phone number is required to grant you access. Please contact us.",
                "email": "Unable to find an account with this email address!",
            },
            "documents": {
                "title": "Signed documents",
                "description": "Download a copy of your signed documents below.",
                "download": "Download",
                "signin": "Sign in as ",
                "allowed": "This field only accepts digital signatures from ",
                "allowed_help": "",
                "sign": "Click to sign",
                "processing": "Processing...",
                "unavailable": "Documents will be available once all signers add their electronic signature.",
                "signed": "Signed by",
                "not_allowed": "Not allowed",
                "not_allowed_message": "This document can be signed but cannot be modified because it already contains a digital signature from another signer.",
            },
            "pdfs": {
                "title": "Generated documents",
                "description": "Download a copy of your documents below.",
                "open": "Open"
            },
            "visibility": {
                "page": {
                    "preview": "This page is visible in advisor preview only."
                },
                "group": {
                    "preview": "This group is visible in advisor preview only."
                },
                "field": {
                    "preview": "This field is visible in advisor preview only."
                }
            }
        },
        "pdffront": {
            "buttons": {
                "next": "Next",
                "previous": "Prev",
                "finish": "Finish",
                "start": "Start",
                "download": "Download documentation",
                "cancel": "Cancel",
                "verify": "Verify",
                "create": "Create",
                "forgot": "Forgot your password?",
                "signin": "Sign-in",
                "pin": "Send me the PIN",
                "document": "Document",
                "of": "of",
                "the": "the",
                "on": "on",
                "and": "and",
                "sign": "Sign",
                "type": "Type",
                "draw": "Draw",
                "signedby": "Signed by",
                "other": "other document",
                "next_esignature": "Navigate to next e-signature",
            },
            "finish": {
                "title": "You're all done!",
                "message": "Once everyone has signed, you will receive a copy of the documentation.",
                "close": "You may close this window.",
            },
            "validation": {
                "message": "There are missing or invalid fields.",
                "confirm": "Are you sure you wish to continue?",
                "page": "Requested on page",
            },
            "disclosure": {
                "title": "Electronic Record and Signature Disclosure",
                "message": "By accessing this engagement, you agree to the"
            },
            "auth": {
                "title": "Verify your identity",
                "pin_message": "Please enter the security PIN sent to your",
                "pin_sms": "mobile phone number",
                "pin_email": "email address",
                "pin_number": "Security PIN",
                "password_message": "Please input your secure password.",
                "password_forgot": "To create a new secure password you need to enter a <strong>security PIN</strong> sent to",
                "password_create": "Please create your secure password.",
                "download_message": "To access this documentation you need to enter a <strong>security PIN</strong> sent to",
                "password_error": "Invalid password!",
                "password": "Password",
                "password_confirm": "Confirm password",
                "pin_error": "Invalid security PIN!",
                "error_message": "Please verify your input and try again.",
                "pin_help": "If you did not receive a security PIN, please contact us.",
                "sms_body": "Your security PIN is:",
                "email_subject": "Security PIN for the documentation package:",
                "email_greeting": "Dear",
                "email_body": "Below is the Security PIN to access the documentation package:",
            },
            "closed": {
                "title": "This engagement has already been completed.",
                "description": "If you wish to continue working in this engagement, please contact us.",
            },
            "blocked": {
                "title": "You have been blocked because of too many failed attempts!",
                "description": "Please contact us in order to verify your information and restore your access."
            },
            "error": {
                "title": "An unexpected error has occurred!",
                "description": "Please close this window and try again by clicking the button in the initial email you received."
            },
        },
        "validation": {
            "address_usps": "The {attribute} does not appear to be a USPS valid address. {error}",
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "{attribute} is a required field.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "captcha": "Invalid captcha. Please refresh the page and try again.",
            "strength": {
                "invalid": "Invalid password",
                "weak": "Weak password",
                "strong": "Strong password"
            },
            "confirmation": "The {attribute} does not match.",
            "password": "The password you provided is incorrect.",
            "mfa": "The verification code is incorrect.",
            "duplicated": "All values must be unique.",
            "mandatory": "This field is mandatory.",
            "expression": "The calculations are invalid! Please check that all parameters are filled in correctly.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
